

exports.__esModule = true;
exports.$EndRoute = undefined;

require('components/xo-models/src/checkout/index');

require('components/xo-return-to-merchant/dist/util');

var _returnParams = require('components/xo-page-components/src/returnParams');

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var $EndRoute = exports.$EndRoute = _squid.$ComponentRoute.extend('EndRoute', {

    path: 'end',

    trackingData: {
        fptiState: 'back_to_merchant',
        trackStateExit: true
    },

    resolve: {
        action: function action($q, $window, $util, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutSessionModel, $ReturnToMerchant, $rootScope, $populate, $MerchantPreferenceModel, $CheckoutPayeeModel, $unresolved) {

            function returnMethod(merchantPreferences) {
                if (_squid.$integration.getConfig('RETURN_METHOD_BASED_ON_MERCHANT_PREFS') && merchantPreferences) {
                    return merchantPreferences.returnMethod();
                } else {
                    return 'GET';
                }
            }

            function returnUrl(checkoutAppData, merchantPreferences) {
                // When "redirect_uri" is passed as a query param
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
                    return $util.param('redirect_uri');
                }

                if (_squid.$integration.getConfig('RETURN_URL_FROM_MERCHANT_PREFS') && merchantPreferences) {
                    return checkoutAppData.urls.return_url || merchantPreferences.returnUrl();
                }

                // By default, use return_uri from checkout session
                return checkoutAppData.urls.return_url;
            }

            function returnParams(checkoutCart, checkoutSession, checkoutAppData, returnToMerchantMethod) {

                var params = {};

                // Don't post PayerID for RT without purchase
                if (_squid.$integration.getConfig('ALLOW_PAYER_ID_RETURN_PARAM') && !checkoutCart.isBillingNoPurchase()) {
                    params.PayerID = checkoutSession.payer.id;
                }

                var billingData = checkoutCart.billing;

                if (billingData && billingData.ba_token && !checkoutAppData.legacy_billing_integration) {
                    params.ba_token = billingData.ba_token;
                }

                if (_squid.$integration.isFlow('WPS')) {
                    var isCartUpload = checkoutAppData.flags.is_cart_upload_flow || checkoutAppData.flags.is_shopping_cart_flow;
                    params = (0, _returnParams.$returnParams)(checkoutCart, checkoutSession, returnToMerchantMethod, 'WPS', isCartUpload);
                }

                // When "redirect_uri" is passed as a query param
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
                    params.opType = 'payment';
                    params.token = $rootScope.token;
                    params.return_uri = $util.buildURL(checkoutAppData.urls.return_url, params);
                }

                return params;
            }

            function getMerchantPreferences(dataModel) {
                if (_squid.$integration.getConfig('POPULATE_MERCHANT_PREFERENCES')) {
                    return $populate(dataModel, {
                        merchantPreferences: $MerchantPreferenceModel.instance(dataModel.payee.merchant.id)
                    });
                } else {
                    return $q.when();
                }
            }

            var models = {};

            return $populate(models, {
                checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
                checkoutCart: $CheckoutCartModel.instance($rootScope.token),
                checkoutSession: $CheckoutSessionModel.instance($rootScope.token),
                payee: $CheckoutPayeeModel.instance($rootScope.token)
            }).then(function () {
                return getMerchantPreferences(models);
            }).then(function () {
                var url = returnUrl(models.checkoutAppData, models.merchantPreferences);
                var returnToMerchantMethod = returnMethod(models.merchantPreferences);
                var params = returnParams(models.checkoutCart, models.checkoutSession, models.checkoutAppData, returnToMerchantMethod);

                // if V4 in-context integration, we'll call the onAuthorize handler.

                if (window.xchild) {
                    _logger.$logger.done();
                    $rootScope.$emit('loading');

                    var xparams = {
                        paymentToken: $rootScope.token,
                        billingToken: params['ba_token'],
                        payerID: params['PayerID'],
                        paymentID: params['paymentId'] || models.checkoutAppData.payment_id,
                        intent: models.checkoutCart.payment_action
                    };

                    xparams.returnUrl = $util.buildURL(url, params);
                    return window.xprops.onAuthorize(xparams);
                }

                if (returnToMerchantMethod === 'POST') {
                    $ReturnToMerchant.postTo(url, params);
                } else {
                    // if PDT is disabled don't send params in the url
                    if (models.merchantPreferences && !models.merchantPreferences.pdtEnabled()) {
                        return $ReturnToMerchant.goTo(url);
                    }
                    $ReturnToMerchant.goTo($util.buildURL(url, params));
                }

                return $unresolved;
            });
        }
    }
});

angular.value("$EndRoute", $EndRoute);
_returnParams.$returnParams;

_logger.$logger;

_squid.$ComponentRoute;

_squid.$integration;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-end/route.js
// module id = ./pages/xo-end/route.js
// module chunks = 1